type Locale = "de" | "en" | string;

const localeToLanguage = (locale: Locale): string => {
  if (locale === "en") {
    return "en-EN";
  }
  return "de-DE";
};

export const formatMoney = (
  money: number | string | undefined,
  fractionDigits: boolean = true,
  locale: Locale = "de",
) => {
  if (typeof money === "undefined") {
    return "";
  }

  const language = localeToLanguage(locale);
  const number = isNaN(Number(money)) ? 0 : Number(money);

  const formatterOptions: Intl.NumberFormatOptions =
    number % 1 === 0 || !fractionDigits
      ? {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }
      : {
          style: "currency",
          currency: "EUR",
        };

  return new Intl.NumberFormat(language, formatterOptions).format(number);
};

export const formatNumber = (
  value: number | string | undefined,
  fractionDigits: boolean = true,
  locale: Locale = "de",
) => {
  if (typeof value === "undefined") {
    return "";
  }

  const language = localeToLanguage(locale);
  const number = isNaN(Number(value)) ? 0 : Number(value);

  const formatterOptions =
    number % 1 === 0 || !fractionDigits
      ? {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }
      : {};

  return new Intl.NumberFormat(language, formatterOptions).format(number);
};

export const formatPercent = (
  percent: number | string | undefined,
  locale: Locale = "de",
) => {
  if (typeof percent === "undefined") {
    return "";
  }
  const language = localeToLanguage(locale);
  const number = isNaN(Number(percent)) ? 0 : Number(percent) / 100;
  const newNumber = new Intl.NumberFormat(language, {
    style: "percent",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })
    .format(number)
    // eslint-disable-next-line no-irregular-whitespace
    .replace(/ /g, "");

  return newNumber;
};

export const formatRange = (
  from: string | number,
  to: string | number | undefined,
) => {
  if (!to || to === from) {
    return from;
  }

  return `${from} – ${to}`;
};
